import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { checkListService } from "../../../services/checkL";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar"; 
import { Paginator } from "primereact/paginator";
import formatDate from "../../../components/ui/dateFormat";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import useDebounce from "../../../components/ui/useDebounce";
import SysCheckListDetail from "./SysCheckListDetail";
export default function SysCheckList() {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [first, setFirst] = useState(0);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState("");
  const filterChange = (e) => {
    setFilter(e.target.value);
  };
  const debouncedFilter = useDebounce(filter, 600);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    setPage(event.page + 1);
  };

  const { data: apiResponse, isLoading } = useQuery({
    queryKey: ["CheckList", page, rows, debouncedFilter],
    queryFn: () =>
      checkListService.getAllCheckLists(page, rows, debouncedFilter),
  });
  useEffect(() => {
    const totalRecords = apiResponse?.totalItemCount || 0;
    setTotalRecords(totalRecords);
  }, [apiResponse]);

  const checkL = Array.isArray(apiResponse?.data) ? apiResponse.data : [];

  const [selectedList, setSelectedList] = useState(null);

  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.date);
  };
  const rowCountBody = (rowData) => {
    return <span>{rowData?.voucherRows?.length}</span>;
  };

  const handleOpenDialog = (data) => {
    setSelectedList(data);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setSelectedList(null);
    setDialogOpen(false);
  };

  const handlePrint = (rowData) => {

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    iframeDoc.open();
    iframeDoc.write(`
      <html>
        <head>
          <title>Yazdır</title>
  
       <style>
  h1 { text-align: center; }
  @page { margin: 0; }
  body { margin: 0; padding: 20px; box-sizing: border-box; font-family: Arial, sans-serif; }

  .print-content { 
    width: 100%; 
    height: auto; 
    overflow: hidden; 
    margin-top: 20px;
  }

table {
  width: 100%; 
  border-collapse: collapse;
  margin-bottom: 20px;
  background-color: #f9f9f9;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid black;  
}
  
 th, td {
  padding: 12px 15px;
  text-align: left;
  border: 1px solid #ddd; /* Hücre içindeki kenarlıklar için */
}

th {
  background-color: #4CAF50;
  color: white;
  font-weight: bold;
}
 

  td {
    font-size: 14px;
    color: #000;
  }

  td, th {
    border-radius: 5px;
  }

  .flex-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 10px;
    position: relative;
  }

  .flex-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
  }

  .left-column,
  .right-column {
    display: flex;
    flex-direction: column;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
  }

  .center-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }

  table td {
    font-size: 14px;
    color: #000;
  }

  .table-header {
    font-size: 18px;
    font-weight: bold;
    color: #000;
    margin-bottom: 10px;
  }
</style>

        </head>
        <body>
    <div class="flex-container">
  <h1 class="center-title">Talimat Fişi</h1>
  <div class="flex-row">
    <div class="left-column">
      <span >${rowData.currentTitle}</span>
      <span style="font-weight: normal;">${rowData.voucherNo}</span>
    </div>
    <div class="right-column" style="text-align: right;">
      <span>BOYER TEKSTİL</span>
      <span style="font-weight: normal;">${formatDate(rowData.date)}</span>
    </div>
  </div>
</div>
          <div class="print-content">
         
            ${rowData.voucherRows
              .map(
                (voucher) => `
 <table>
  <thead>
    <tr>
      <th colspan="2" style="text-align: center; font-weight: bold; color: #000;">${voucher.stockName}</th>
      <th style="font-weight: bold; color: #000;">Parti No</th>
      <th style="text-align: center; font-weight: bold; color: #000;">${voucher.parcel}</th>
    </tr>
  </thead>
  <tbody>
    <tr>
    <td style="width: 18%; font-weight: bold; color: #000;">İşlem Talimatı</td>
    <td style="text-align: center; width: 40%; ">${voucher.processInstruction}</td>
      <td style="width:  18%; font-weight: bold; color: #000;">Kilo</td>
      <td style="text-align: center; width: 20%;">${voucher.kilos}</td>
    </tr>
    <tr>
      <td style="width:  18%; font-weight: bold; color: #000;">Sarım Şekli</td>
      <td style="text-align: center; width: 40%;">${voucher.rollStyle}</td>
      <td style="width:  18%; font-weight: bold; color: #000;">Metre</td>
      <td style="text-align: center; width: 20%;">${voucher.meters}</td>
    </tr>
    <tr>
      <td style="width:  18%; font-weight: bold; color: #000;">İstenen En</td>
      <td style="text-align: center; width: 40%;">${voucher.requestedWidth}</td>
      <td style="width:  18%; font-weight: bold; color: #000;">Top Sayısı</td>
      <td style="text-align: center; width: 20%;">${voucher.rollCount}</td>
    </tr>
    <tr>
      <td colspan="1" style="width:  18%; font-weight: bold; color: #000;">Not</td>
      <td colspan="3 style="width:  60%; ">${voucher.description}</td>
    </tr>
  </tbody>
</table>



             
            `
              )
              .join("")}
          </div>
        </body>
      </html>
    `);
    iframeDoc.close();

    // Yazdırma işlemi başlat
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Yazdırma tamamlandıktan sonra iframe'i kaldır
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-1">
        <React.Fragment>
          <Button
            icon="pi pi-eye"
            text
            onClick={() => handleOpenDialog(rowData)}
          />

          <Button icon="pi pi-print" onClick={() => handlePrint(rowData)} />
        </React.Fragment>
      </div>
    );
  };

  const footer = (
    <Paginator
      first={first}
      rows={rows}
      totalRecords={totalRecords}
      rowsPerPageOptions={[10, 30, 50]}
      onPageChange={onPageChange}
      className="p-0 m-0 border-none"
      disabled={isLoading} // Yüklenme sırasında paginator'ı devre dışı bırak
    />
  );

  return (
    <div>
      <Toolbar
        className="shadow-3 border-round-md  my-2"
        start={
          <div className="text-2xl font-bold"> Tüm Talimatlar</div>
        }
        end={
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText
              type="search"  
              value={filter || ""}
              className="w-full"
              onChange={(e) => filterChange(e)}
              placeholder="Ara"
            />
          </IconField>
        }
      />
      <DataTable
        className="shadow-3 border-round-md table-content surface-ground  "
        scrollable
        scrollHeight="flex"
        value={checkL}
        loading={isLoading}
        footer={footer}
        emptyMessage="Liste Boş"
      >
        <Column field="id" header="ID" />
        <Column field="date" header="Tarih" body={dateBodyTemplate} />
        <Column field="voucherNo" header="Fiş No" />
        <Column field="currentTitle" header="Ünvan" />
        <Column
          field="rowCount"
          header="Parti Sayısı"
          alignHeader={"center"}
          align={"center"}
          body={rowCountBody}
        />

        <Column
          header="İşlemler"
          alignHeader="center"
          align="center"
          headerStyle={{ width: "4rem", textAlign: "center" }}
          bodyStyle={{ textAlign: "center", overflow: "visible" }}
          body={actionBodyTemplate}
        />
      </DataTable>
      <SysCheckListDetail
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        initialData={selectedList}
      />
    </div>
  );
}
